// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ni[data-v-26f7f6ba] {\n  color: #0c3a54;\n}\n", ""]);
// Exports
module.exports = exports;
